const v = "4.8.0";
const meta = {
  g: "LottieFiles AE 3.1.1",
  a: "",
  k: "",
  d: "",
  tc: ""
};
const fr = 60;
const ip = 0;
const op = 60;
const w = 100;
const h = 100;
const nm = "230208_queda_ox_60";
const ddd = 0;
const assets = [
  {
    id: "image_0",
    w: 12,
    h: 7,
    u: "",
    p: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAHCAYAAAA8sqwkAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAA2UlEQVQYlYWOv07CcBSFv/trY8tkDUnZSIOjDEyu+gKmXdl8BB6BR+gj8Ai6uJgYHqEmsDAYHIyJixXDwJ/e61C6oInf+OWckyPZIImqrUwQF2FaYjI1zxVilmCaIS4CqKhGD/Nl4VcbyRFJMQMEhFRUqRFqDx4yBjIf55JGxmGLThDSPz1j9vXJer/nZf3dlFMAX8ymBlfDbo9ht8cxTx/v5Is5YPcAzp1oDjx3wtavMEAchACvntrocLLm5uL8FtXry3Y8aNxiVb6Vu92jF+jkrliWfy7+xw9HRUssHGijggAAAABJRU5ErkJggg==",
    e: 1
  }
];
const layers = [
  {
    ddd: 0,
    ind: 1,
    ty: 4,
    nm: "모양 레이어 1",
    parent: 4,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.667,
              y: 1
            },
            o: {
              x: 0.626,
              y: 0
            },
            t: 0,
            s: [
              49.5,
              50.875,
              0
            ],
            to: [
              0.083,
              -0.146,
              0
            ],
            ti: [
              -0.083,
              0.146,
              0
            ]
          },
          {
            i: {
              x: 0.667,
              y: 0.667
            },
            o: {
              x: 0.333,
              y: 0.333
            },
            t: 20.02,
            s: [
              50,
              50,
              0
            ],
            to: [
              0,
              0,
              0
            ],
            ti: [
              0,
              0,
              0
            ]
          },
          {
            i: {
              x: 0.362,
              y: 1
            },
            o: {
              x: 0.333,
              y: 0
            },
            t: 40.041,
            s: [
              50,
              50,
              0
            ],
            to: [
              0.208,
              0.146,
              0
            ],
            ti: [
              -0.208,
              -0.146,
              0
            ]
          },
          {
            t: 60.060546875,
            s: [
              51.25,
              50.875,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          0,
          0,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 0,
            s: [
              80,
              80,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 20.02,
            s: [
              100,
              100,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 40.041,
            s: [
              100,
              100,
              100
            ]
          },
          {
            t: 60.060546875,
            s: [
              80,
              80,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 1,
              k: [
                {
                  i: {
                    x: 0.667,
                    y: 1
                  },
                  o: {
                    x: 0.626,
                    y: 0
                  },
                  t: 0,
                  s: [
                    {
                      i: [
                        [
                          1.501,
                          -0.062
                        ],
                        [
                          0,
                          -0.937
                        ],
                        [
                          -1.624,
                          0
                        ],
                        [
                          0,
                          1.125
                        ]
                      ],
                      o: [
                        [
                          -1.248,
                          0.052
                        ],
                        [
                          0,
                          1.313
                        ],
                        [
                          1.313,
                          0
                        ],
                        [
                          0,
                          -0.937
                        ]
                      ],
                      v: [
                        [
                          -0.672,
                          5.187
                        ],
                        [
                          -2.234,
                          7.313
                        ],
                        [
                          -0.234,
                          9.75
                        ],
                        [
                          1.141,
                          7.313
                        ]
                      ],
                      c: true
                    }
                  ]
                },
                {
                  i: {
                    x: 0.667,
                    y: 1
                  },
                  o: {
                    x: 0.333,
                    y: 0
                  },
                  t: 20.02,
                  s: [
                    {
                      i: [
                        [
                          1.875,
                          0
                        ],
                        [
                          0.188,
                          -0.094
                        ],
                        [
                          -2.25,
                          0
                        ],
                        [
                          0.063,
                          0.063
                        ]
                      ],
                      o: [
                        [
                          -1.875,
                          0
                        ],
                        [
                          -0.141,
                          0.047
                        ],
                        [
                          2.281,
                          0
                        ],
                        [
                          -0.094,
                          0
                        ]
                      ],
                      v: [
                        [
                          -0.031,
                          8.469
                        ],
                        [
                          -2.609,
                          6.438
                        ],
                        [
                          0,
                          8.469
                        ],
                        [
                          2.656,
                          6.453
                        ]
                      ],
                      c: true
                    }
                  ]
                },
                {
                  i: {
                    x: 0.362,
                    y: 1
                  },
                  o: {
                    x: 0.333,
                    y: 0
                  },
                  t: 40.041,
                  s: [
                    {
                      i: [
                        [
                          1.875,
                          0
                        ],
                        [
                          0.188,
                          -0.094
                        ],
                        [
                          -2.25,
                          0
                        ],
                        [
                          0.063,
                          0.063
                        ]
                      ],
                      o: [
                        [
                          -1.875,
                          0
                        ],
                        [
                          -0.141,
                          0.047
                        ],
                        [
                          2.281,
                          0
                        ],
                        [
                          -0.094,
                          0
                        ]
                      ],
                      v: [
                        [
                          -0.031,
                          8.469
                        ],
                        [
                          -2.609,
                          6.438
                        ],
                        [
                          0,
                          8.469
                        ],
                        [
                          2.656,
                          6.453
                        ]
                      ],
                      c: true
                    }
                  ]
                },
                {
                  t: 60.060546875,
                  s: [
                    {
                      i: [
                        [
                          1.501,
                          -0.062
                        ],
                        [
                          0,
                          -0.937
                        ],
                        [
                          -1.624,
                          0
                        ],
                        [
                          0,
                          1.125
                        ]
                      ],
                      o: [
                        [
                          -1.248,
                          0.052
                        ],
                        [
                          0,
                          1.313
                        ],
                        [
                          1.313,
                          0
                        ],
                        [
                          0,
                          -0.937
                        ]
                      ],
                      v: [
                        [
                          -0.672,
                          5.187
                        ],
                        [
                          -2.234,
                          7.313
                        ],
                        [
                          -0.234,
                          9.75
                        ],
                        [
                          1.141,
                          7.313
                        ]
                      ],
                      c: true
                    }
                  ]
                }
              ],
              ix: 2
            },
            nm: "패스 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                0.301960784314,
                0.164705882353,
                0.133333333333,
                1
              ],
              ix: 3
            },
            o: {
              a: 0,
              k: 100,
              ix: 4
            },
            w: {
              a: 0,
              k: 2,
              ix: 5
            },
            lc: 1,
            lj: 1,
            ml: 4,
            bm: 0,
            nm: "선 1",
            mn: "ADBE Vector Graphic - Stroke",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.301960784314,
                0.164705882353,
                0.133333333333,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "칠 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "모양 1",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }
    ],
    ip: 0,
    op: 60,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 2,
    ty: 4,
    nm: "레이어 10 윤곽선",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          86.268,
          62.964,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          9.257,
          9.257,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    -76.635,
                    -53.956
                  ]
                ],
                c: false
              },
              ix: 2
            },
            nm: "패스 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                1,
                0.882353001015,
                1,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "칠 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "모양 1",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      },
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -4.975,
                    0
                  ],
                  [
                    0,
                    4.974
                  ],
                  [
                    4.975,
                    0
                  ],
                  [
                    0,
                    -4.975
                  ]
                ],
                o: [
                  [
                    4.975,
                    0
                  ],
                  [
                    0,
                    -4.975
                  ],
                  [
                    -4.975,
                    0
                  ],
                  [
                    0,
                    4.974
                  ]
                ],
                v: [
                  [
                    0,
                    9.007
                  ],
                  [
                    9.007,
                    1e-3
                  ],
                  [
                    0,
                    -9.007
                  ],
                  [
                    -9.007,
                    1e-3
                  ]
                ],
                c: true
              },
              ix: 2
            },
            nm: "패스 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "mm",
            mm: 4,
            nm: "패스 병합 1",
            mn: "ADBE Vector Filter - Merge",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.886274569642,
                0.321568627451,
                0.321568627451,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "칠 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                9.257,
                9.257
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "그룹 1",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 2,
        mn: "ADBE Vector Group",
        hd: false
      }
    ],
    ip: 0,
    op: 60,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 3,
    ty: 4,
    nm: "레이어 8 윤곽선",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          15.896,
          62.964,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          9.257,
          9.257,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    -6.764,
                    -53.331
                  ]
                ],
                c: false
              },
              ix: 2
            },
            nm: "패스 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                1,
                0.882353001015,
                1,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "칠 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "모양 1",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      },
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -4.975,
                    0
                  ],
                  [
                    0,
                    4.974
                  ],
                  [
                    4.975,
                    0
                  ],
                  [
                    0,
                    -4.975
                  ]
                ],
                o: [
                  [
                    4.975,
                    0
                  ],
                  [
                    0,
                    -4.975
                  ],
                  [
                    -4.975,
                    0
                  ],
                  [
                    0,
                    4.974
                  ]
                ],
                v: [
                  [
                    0,
                    9.007
                  ],
                  [
                    9.007,
                    1e-3
                  ],
                  [
                    0,
                    -9.007
                  ],
                  [
                    -9.007,
                    1e-3
                  ]
                ],
                c: true
              },
              ix: 2
            },
            nm: "패스 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "mm",
            mm: 4,
            nm: "패스 병합 1",
            mn: "ADBE Vector Filter - Merge",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.886274569642,
                0.321568627451,
                0.321568627451,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "칠 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                9.257,
                9.257
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "그룹 1",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 2,
        mn: "ADBE Vector Group",
        hd: false
      }
    ],
    ip: 0,
    op: 60,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 4,
    ty: 3,
    nm: "face",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 0,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.667,
              y: 1
            },
            o: {
              x: 0.626,
              y: 0
            },
            t: 0,
            s: [
              42.5,
              47,
              0
            ],
            to: [
              1.25,
              0.5,
              0
            ],
            ti: [
              -1.25,
              -0.5,
              0
            ]
          },
          {
            i: {
              x: 0.667,
              y: 0.667
            },
            o: {
              x: 0.333,
              y: 0.333
            },
            t: 20.02,
            s: [
              50,
              50,
              0
            ],
            to: [
              0,
              0,
              0
            ],
            ti: [
              0,
              0,
              0
            ]
          },
          {
            i: {
              x: 0.362,
              y: 1
            },
            o: {
              x: 0.333,
              y: 0
            },
            t: 40.041,
            s: [
              50,
              50,
              0
            ],
            to: [
              1.25,
              -0.5,
              0
            ],
            ti: [
              -1.25,
              0.5,
              0
            ]
          },
          {
            t: 60.060546875,
            s: [
              57.5,
              47,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          50,
          50,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 0,
    op: 60,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 5,
    ty: 4,
    nm: "eye",
    parent: 4,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.667,
              y: 1
            },
            o: {
              x: 0.626,
              y: 0
            },
            t: 0,
            s: [
              57.618,
              49.287,
              0
            ],
            to: [
              0.042,
              0,
              0
            ],
            ti: [
              -0.042,
              0,
              0
            ]
          },
          {
            i: {
              x: 0.667,
              y: 0.667
            },
            o: {
              x: 0.333,
              y: 0.333
            },
            t: 20.02,
            s: [
              57.868,
              49.287,
              0
            ],
            to: [
              0,
              0,
              0
            ],
            ti: [
              0,
              0,
              0
            ]
          },
          {
            i: {
              x: 0.362,
              y: 1
            },
            o: {
              x: 0.333,
              y: 0
            },
            t: 40.041,
            s: [
              57.868,
              49.287,
              0
            ],
            to: [
              0.417,
              0,
              0
            ],
            ti: [
              -0.417,
              0,
              0
            ]
          },
          {
            t: 60.060546875,
            s: [
              60.368,
              49.287,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          4.699,
          4.699,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -0.506,
                    0.471
                  ],
                  [
                    0.391,
                    0.42
                  ],
                  [
                    0.506,
                    -0.472
                  ],
                  [
                    -0.39,
                    -0.419
                  ]
                ],
                o: [
                  [
                    0.506,
                    -0.471
                  ],
                  [
                    -0.39,
                    -0.419
                  ],
                  [
                    -0.506,
                    0.472
                  ],
                  [
                    0.391,
                    0.419
                  ]
                ],
                v: [
                  [
                    0.707,
                    0.759
                  ],
                  [
                    0.916,
                    -0.854
                  ],
                  [
                    -0.707,
                    -0.759
                  ],
                  [
                    -0.917,
                    0.854
                  ]
                ],
                c: true
              },
              ix: 2
            },
            nm: "패스 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "mm",
            mm: 4,
            nm: "패스 병합 1",
            mn: "ADBE Vector Filter - Merge",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.517647058824,
                0.254901960784,
                0.192156877705,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "칠 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                6.614,
                6.834
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "그룹 1",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      },
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -0.82,
                    0.764
                  ],
                  [
                    0.632,
                    0.679
                  ],
                  [
                    0.819,
                    -0.763
                  ],
                  [
                    -0.632,
                    -0.679
                  ]
                ],
                o: [
                  [
                    0.82,
                    -0.764
                  ],
                  [
                    -0.632,
                    -0.678
                  ],
                  [
                    -0.82,
                    0.764
                  ],
                  [
                    0.632,
                    0.679
                  ]
                ],
                v: [
                  [
                    1.145,
                    1.229
                  ],
                  [
                    1.484,
                    -1.383
                  ],
                  [
                    -1.145,
                    -1.229
                  ],
                  [
                    -1.484,
                    1.383
                  ]
                ],
                c: true
              },
              ix: 2
            },
            nm: "패스 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "mm",
            mm: 4,
            nm: "패스 병합 1",
            mn: "ADBE Vector Filter - Merge",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                1,
                1,
                1,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "칠 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                3.501,
                2.974
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "그룹 2",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 2,
        mn: "ADBE Vector Group",
        hd: false
      },
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -2.449,
                    0.014
                  ],
                  [
                    0.014,
                    2.449
                  ],
                  [
                    2.449,
                    -0.014
                  ],
                  [
                    -0.014,
                    -2.45
                  ]
                ],
                o: [
                  [
                    2.449,
                    -0.014
                  ],
                  [
                    -0.014,
                    -2.45
                  ],
                  [
                    -2.449,
                    0.015
                  ],
                  [
                    0.014,
                    2.449
                  ]
                ],
                v: [
                  [
                    0.025,
                    4.435
                  ],
                  [
                    4.434,
                    -0.025
                  ],
                  [
                    -0.025,
                    -4.435
                  ],
                  [
                    -4.434,
                    0.026
                  ]
                ],
                c: true
              },
              ix: 2
            },
            nm: "패스 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "mm",
            mm: 4,
            nm: "패스 병합 1",
            mn: "ADBE Vector Filter - Merge",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.301960784314,
                0.164705882353,
                0.133333333333,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "칠 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                4.699,
                4.699
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "그룹 3",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 3,
        mn: "ADBE Vector Group",
        hd: false
      }
    ],
    ip: 0,
    op: 60,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 6,
    ty: 4,
    nm: "eye",
    parent: 4,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.667,
              y: 1
            },
            o: {
              x: 0.626,
              y: 0
            },
            t: 0,
            s: [
              38.921,
              49.286,
              0
            ],
            to: [
              0.417,
              0,
              0
            ],
            ti: [
              -0.417,
              0,
              0
            ]
          },
          {
            i: {
              x: 0.667,
              y: 0.667
            },
            o: {
              x: 0.333,
              y: 0.333
            },
            t: 20.02,
            s: [
              41.421,
              49.286,
              0
            ],
            to: [
              0,
              0,
              0
            ],
            ti: [
              0,
              0,
              0
            ]
          },
          {
            i: {
              x: 0.362,
              y: 1
            },
            o: {
              x: 0.333,
              y: 0
            },
            t: 40.041,
            s: [
              41.421,
              49.286,
              0
            ],
            to: [
              0.042,
              0,
              0
            ],
            ti: [
              -0.042,
              0,
              0
            ]
          },
          {
            t: 60.060546875,
            s: [
              41.671,
              49.286,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          4.699,
          4.699,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -0.506,
                    0.472
                  ],
                  [
                    0.391,
                    0.42
                  ],
                  [
                    0.506,
                    -0.471
                  ],
                  [
                    -0.391,
                    -0.419
                  ]
                ],
                o: [
                  [
                    0.506,
                    -0.471
                  ],
                  [
                    -0.39,
                    -0.419
                  ],
                  [
                    -0.506,
                    0.472
                  ],
                  [
                    0.39,
                    0.419
                  ]
                ],
                v: [
                  [
                    0.707,
                    0.759
                  ],
                  [
                    0.916,
                    -0.854
                  ],
                  [
                    -0.707,
                    -0.759
                  ],
                  [
                    -0.916,
                    0.854
                  ]
                ],
                c: true
              },
              ix: 2
            },
            nm: "패스 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "mm",
            mm: 4,
            nm: "패스 병합 1",
            mn: "ADBE Vector Filter - Merge",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.517647058824,
                0.254901960784,
                0.192156877705,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "칠 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                6.614,
                6.835
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "그룹 1",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      },
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -0.82,
                    0.764
                  ],
                  [
                    0.632,
                    0.679
                  ],
                  [
                    0.819,
                    -0.763
                  ],
                  [
                    -0.632,
                    -0.679
                  ]
                ],
                o: [
                  [
                    0.82,
                    -0.764
                  ],
                  [
                    -0.633,
                    -0.678
                  ],
                  [
                    -0.82,
                    0.764
                  ],
                  [
                    0.632,
                    0.679
                  ]
                ],
                v: [
                  [
                    1.145,
                    1.229
                  ],
                  [
                    1.484,
                    -1.383
                  ],
                  [
                    -1.145,
                    -1.229
                  ],
                  [
                    -1.484,
                    1.383
                  ]
                ],
                c: true
              },
              ix: 2
            },
            nm: "패스 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "mm",
            mm: 4,
            nm: "패스 병합 1",
            mn: "ADBE Vector Filter - Merge",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                1,
                1,
                1,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "칠 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                3.502,
                2.975
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "그룹 2",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 2,
        mn: "ADBE Vector Group",
        hd: false
      },
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -2.449,
                    0.014
                  ],
                  [
                    0.014,
                    2.449
                  ],
                  [
                    2.449,
                    -0.015
                  ],
                  [
                    -0.014,
                    -2.449
                  ]
                ],
                o: [
                  [
                    2.449,
                    -0.014
                  ],
                  [
                    -0.014,
                    -2.45
                  ],
                  [
                    -2.449,
                    0.014
                  ],
                  [
                    0.014,
                    2.449
                  ]
                ],
                v: [
                  [
                    0.025,
                    4.435
                  ],
                  [
                    4.434,
                    -0.025
                  ],
                  [
                    -0.025,
                    -4.434
                  ],
                  [
                    -4.434,
                    0.026
                  ]
                ],
                c: true
              },
              ix: 2
            },
            nm: "패스 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "mm",
            mm: 4,
            nm: "패스 병합 1",
            mn: "ADBE Vector Filter - Merge",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.301960784314,
                0.164705882353,
                0.133333333333,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "칠 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                4.698,
                4.699
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "그룹 3",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 3,
        mn: "ADBE Vector Group",
        hd: false
      }
    ],
    ip: 0,
    op: 60,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 7,
    ty: 4,
    nm: "brow",
    parent: 4,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.667,
              y: 1
            },
            o: {
              x: 0.626,
              y: 0
            },
            t: 0,
            s: [
              49.655,
              33.544,
              0
            ],
            to: [
              0,
              -0.292,
              0
            ],
            ti: [
              0,
              0.292,
              0
            ]
          },
          {
            i: {
              x: 0.667,
              y: 0.667
            },
            o: {
              x: 0.333,
              y: 0.333
            },
            t: 20.02,
            s: [
              49.655,
              31.794,
              0
            ],
            to: [
              0,
              0,
              0
            ],
            ti: [
              0,
              0,
              0
            ]
          },
          {
            i: {
              x: 0.362,
              y: 1
            },
            o: {
              x: 0.333,
              y: 0
            },
            t: 40.041,
            s: [
              49.655,
              31.794,
              0
            ],
            to: [
              -0.125,
              0.292,
              0
            ],
            ti: [
              0.125,
              -0.292,
              0
            ]
          },
          {
            t: 60.060546875,
            s: [
              48.905,
              33.544,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          15.311,
          2.939,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    -2.367,
                    0.448
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    2.452,
                    -0.466
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    -3.393,
                    1.439
                  ],
                  [
                    -0.338,
                    -0.973
                  ],
                  [
                    3.393,
                    0.152
                  ]
                ],
                c: false
              },
              ix: 2
            },
            nm: "패스 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                0.807843197093,
                0.243137269862,
                0.243137269862,
                1
              ],
              ix: 3
            },
            o: {
              a: 0,
              k: 100,
              ix: 4
            },
            w: {
              a: 0,
              k: 1.5,
              ix: 5
            },
            lc: 2,
            lj: 2,
            bm: 0,
            nm: "선 1",
            mn: "ADBE Vector Graphic - Stroke",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                4.892,
                2.94
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "그룹 1",
        np: 2,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      },
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    2.367,
                    0.448
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -2.452,
                    -0.466
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.393,
                    1.439
                  ],
                  [
                    0.337,
                    -0.973
                  ],
                  [
                    -3.393,
                    0.152
                  ]
                ],
                c: false
              },
              ix: 2
            },
            nm: "패스 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                0.807843197093,
                0.243137269862,
                0.243137269862,
                1
              ],
              ix: 3
            },
            o: {
              a: 0,
              k: 100,
              ix: 4
            },
            w: {
              a: 0,
              k: 1.5,
              ix: 5
            },
            lc: 2,
            lj: 2,
            bm: 0,
            nm: "선 1",
            mn: "ADBE Vector Graphic - Stroke",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                25.729,
                2.94
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "그룹 2",
        np: 2,
        cix: 2,
        bm: 0,
        ix: 2,
        mn: "ADBE Vector Group",
        hd: false
      }
    ],
    ip: 0,
    op: 60,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 8,
    ty: 4,
    nm: "cheek",
    parent: 4,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          49.596,
          53.925,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          24.692,
          4.057,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ind: 0,
        ty: "sh",
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                7.444,
                4.947
              ],
              [
                3.821,
                4.947
              ]
            ],
            c: false
          },
          ix: 2
        },
        nm: "패스 1",
        mn: "ADBE Vector Shape - Group",
        hd: false
      },
      {
        ty: "st",
        c: {
          a: 0,
          k: [
            0.835294177485,
            0.254901960784,
            0.254901960784,
            1
          ],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 1,
          ix: 5
        },
        lc: 2,
        lj: 2,
        bm: 0,
        nm: "선 1",
        mn: "ADBE Vector Graphic - Stroke",
        hd: false
      },
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    1.812,
                    0.335
                  ],
                  [
                    -1.812,
                    -0.335
                  ]
                ],
                c: false
              },
              ix: 2
            },
            nm: "패스 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                0.835294177485,
                0.254901960784,
                0.254901960784,
                1
              ],
              ix: 3
            },
            o: {
              a: 0,
              k: 100,
              ix: 4
            },
            w: {
              a: 0,
              k: 1,
              ix: 5
            },
            lc: 2,
            lj: 2,
            bm: 0,
            nm: "선 1",
            mn: "ADBE Vector Graphic - Stroke",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                5.632,
                2.883
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "그룹 2",
        np: 2,
        cix: 2,
        bm: 0,
        ix: 3,
        mn: "ADBE Vector Group",
        hd: false
      },
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -2.987,
                    0
                  ],
                  [
                    0,
                    2.24
                  ],
                  [
                    2.987,
                    0
                  ],
                  [
                    0,
                    -2.241
                  ]
                ],
                o: [
                  [
                    2.987,
                    0
                  ],
                  [
                    0,
                    -2.241
                  ],
                  [
                    -2.987,
                    0
                  ],
                  [
                    0,
                    2.24
                  ]
                ],
                v: [
                  [
                    0,
                    4.057
                  ],
                  [
                    5.409,
                    0
                  ],
                  [
                    0,
                    -4.058
                  ],
                  [
                    -5.409,
                    0
                  ]
                ],
                c: true
              },
              ix: 2
            },
            nm: "패스 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "mm",
            mm: 4,
            nm: "패스 병합 1",
            mn: "ADBE Vector Filter - Merge",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.992156922583,
                0.937254961799,
                0.937254961799,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 30,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "칠 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                5.409,
                4.057
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "그룹 3",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 4,
        mn: "ADBE Vector Group",
        hd: false
      },
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    41.94,
                    4.947
                  ],
                  [
                    45.567,
                    4.947
                  ]
                ],
                c: false
              },
              ix: 2
            },
            nm: "패스 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                0.835294177485,
                0.254901960784,
                0.254901960784,
                1
              ],
              ix: 3
            },
            o: {
              a: 0,
              k: 100,
              ix: 4
            },
            w: {
              a: 0,
              k: 1,
              ix: 5
            },
            lc: 2,
            lj: 2,
            bm: 0,
            nm: "선 1",
            mn: "ADBE Vector Graphic - Stroke",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "그룹 4",
        np: 2,
        cix: 2,
        bm: 0,
        ix: 5,
        mn: "ADBE Vector Group",
        hd: false
      },
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    -1.814,
                    0.335
                  ],
                  [
                    1.814,
                    -0.335
                  ]
                ],
                c: false
              },
              ix: 2
            },
            nm: "패스 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                0.835294177485,
                0.254901960784,
                0.254901960784,
                1
              ],
              ix: 3
            },
            o: {
              a: 0,
              k: 100,
              ix: 4
            },
            w: {
              a: 0,
              k: 1,
              ix: 5
            },
            lc: 2,
            lj: 2,
            bm: 0,
            nm: "선 1",
            mn: "ADBE Vector Graphic - Stroke",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                43.754,
                2.883
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "그룹 5",
        np: 2,
        cix: 2,
        bm: 0,
        ix: 6,
        mn: "ADBE Vector Group",
        hd: false
      },
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -2.987,
                    0
                  ],
                  [
                    0,
                    2.24
                  ],
                  [
                    2.987,
                    0
                  ],
                  [
                    0,
                    -2.241
                  ]
                ],
                o: [
                  [
                    2.987,
                    0
                  ],
                  [
                    0,
                    -2.241
                  ],
                  [
                    -2.987,
                    0
                  ],
                  [
                    0,
                    2.24
                  ]
                ],
                v: [
                  [
                    0,
                    4.057
                  ],
                  [
                    5.409,
                    0
                  ],
                  [
                    0,
                    -4.058
                  ],
                  [
                    -5.409,
                    0
                  ]
                ],
                c: true
              },
              ix: 2
            },
            nm: "패스 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "mm",
            mm: 4,
            nm: "패스 병합 1",
            mn: "ADBE Vector Filter - Merge",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.992156922583,
                0.937254961799,
                0.937254961799,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 30,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "칠 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                43.976,
                4.057
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "그룹 6",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 7,
        mn: "ADBE Vector Group",
        hd: false
      }
    ],
    ip: 0,
    op: 60,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 9,
    ty: 4,
    nm: "eye",
    parent: 4,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          49.655,
          48.82,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          16.305,
          6.41,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    -3.475
                  ],
                  [
                    3.539,
                    0
                  ],
                  [
                    0,
                    3.479
                  ],
                  [
                    -3.539,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    3.475
                  ],
                  [
                    -3.539,
                    0
                  ],
                  [
                    0,
                    -3.475
                  ],
                  [
                    3.539,
                    0
                  ]
                ],
                v: [
                  [
                    6.407,
                    0.402
                  ],
                  [
                    0,
                    6.16
                  ],
                  [
                    -6.407,
                    0.402
                  ],
                  [
                    0,
                    -6.16
                  ]
                ],
                c: true
              },
              ix: 2
            },
            nm: "패스 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "mm",
            mm: 4,
            nm: "패스 병합 1",
            mn: "ADBE Vector Filter - Merge",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                1,
                1,
                1,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "칠 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                25.952,
                6.41
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "그룹 1",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      },
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    -3.475
                  ],
                  [
                    3.539,
                    0
                  ],
                  [
                    0,
                    3.479
                  ],
                  [
                    -3.539,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    3.475
                  ],
                  [
                    -3.539,
                    0
                  ],
                  [
                    0,
                    -3.475
                  ],
                  [
                    3.539,
                    0
                  ]
                ],
                v: [
                  [
                    6.407,
                    0.402
                  ],
                  [
                    0,
                    6.16
                  ],
                  [
                    -6.407,
                    0.402
                  ],
                  [
                    0,
                    -6.16
                  ]
                ],
                c: true
              },
              ix: 2
            },
            nm: "패스 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "mm",
            mm: 4,
            nm: "패스 병합 1",
            mn: "ADBE Vector Filter - Merge",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                1,
                1,
                1,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "칠 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                6.657,
                6.41
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "그룹 2",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 2,
        mn: "ADBE Vector Group",
        hd: false
      }
    ],
    ip: 0,
    op: 60,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 10,
    ty: 4,
    nm: "레이어 5 윤곽선",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          49.656,
          48.643,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          34.646,
          35.468,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        -1.203,
                        2.321
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    v: [
                      [
                        0.426,
                        2.512
                      ],
                      [
                        0.602,
                        -2.512
                      ]
                    ],
                    c: false
                  },
                  ix: 2
                },
                nm: "패스 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.694117647059,
                    0.160784313725,
                    0.160784313725,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 1.2,
                  ix: 5
                },
                lc: 2,
                lj: 2,
                bm: 0,
                nm: "선 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    34.308,
                    3.712
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "변형"
              }
            ],
            nm: "그룹 1",
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          },
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        -0.536,
                        2.557
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    v: [
                      [
                        0.542,
                        2.069
                      ],
                      [
                        -6e-3,
                        -2.069
                      ]
                    ],
                    c: false
                  },
                  ix: 2
                },
                nm: "패스 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.694117647059,
                    0.160784313725,
                    0.160784313725,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 1.2,
                  ix: 5
                },
                lc: 2,
                lj: 2,
                bm: 0,
                nm: "선 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    32.541,
                    4.155
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "변형"
              }
            ],
            nm: "그룹 2",
            np: 2,
            cix: 2,
            bm: 0,
            ix: 2,
            mn: "ADBE Vector Group",
            hd: false
          },
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        -1.203,
                        2.321
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    v: [
                      [
                        0.101,
                        2.074
                      ],
                      [
                        0.602,
                        -2.074
                      ]
                    ],
                    c: false
                  },
                  ix: 2
                },
                nm: "패스 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.694117647059,
                    0.160784313725,
                    0.160784313725,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 1.2,
                  ix: 5
                },
                lc: 2,
                lj: 2,
                bm: 0,
                nm: "선 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    36.301,
                    4.149
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "변형"
              }
            ],
            nm: "그룹 3",
            np: 2,
            cix: 2,
            bm: 0,
            ix: 3,
            mn: "ADBE Vector Group",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 1,
              k: [
                {
                  i: {
                    x: 0.667,
                    y: 1
                  },
                  o: {
                    x: 0.626,
                    y: 0
                  },
                  t: 0,
                  s: [
                    28.644,
                    3.712
                  ],
                  to: [
                    1,
                    0
                  ],
                  ti: [
                    -1,
                    0
                  ]
                },
                {
                  i: {
                    x: 0.667,
                    y: 0.667
                  },
                  o: {
                    x: 0.333,
                    y: 0.333
                  },
                  t: 20.02,
                  s: [
                    34.644,
                    3.712
                  ],
                  to: [
                    0,
                    0
                  ],
                  ti: [
                    0,
                    0
                  ]
                },
                {
                  i: {
                    x: 0.362,
                    y: 1
                  },
                  o: {
                    x: 0.333,
                    y: 0
                  },
                  t: 40.041,
                  s: [
                    34.644,
                    3.712
                  ],
                  to: [
                    0.833,
                    0
                  ],
                  ti: [
                    -0.833,
                    0
                  ]
                },
                {
                  t: 60.060546875,
                  s: [
                    39.644,
                    3.712
                  ]
                }
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                34.644,
                3.712
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "그룹 5",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      },
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    -18.466
                  ],
                  [
                    18.996,
                    0
                  ],
                  [
                    0,
                    18.466
                  ],
                  [
                    -18.995,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    18.466
                  ],
                  [
                    -18.995,
                    0
                  ],
                  [
                    0,
                    -18.466
                  ],
                  [
                    18.996,
                    0
                  ]
                ],
                v: [
                  [
                    34.396,
                    2.484
                  ],
                  [
                    -1e-3,
                    32.727
                  ],
                  [
                    -34.396,
                    2.484
                  ],
                  [
                    -1e-3,
                    -32.727
                  ]
                ],
                c: true
              },
              ix: 2
            },
            nm: "패스 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "mm",
            mm: 4,
            nm: "패스 병합 1",
            mn: "ADBE Vector Filter - Merge",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                1,
                0.400000029919,
                0.400000029919,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "칠 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                34.646,
                37.959
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "그룹 4",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 2,
        mn: "ADBE Vector Group",
        hd: false
      }
    ],
    ip: 0,
    op: 60,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 11,
    ty: 2,
    nm: "레이어 7/230208_queda_ox.ai",
    cl: "ai",
    refId: "image_0",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          50,
          50,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          6,
          3.5,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 0,
    op: 60,
    st: 0,
    bm: 0
  }
];
const markers = [];
const quedaAnim = {
  v,
  meta,
  fr,
  ip,
  op,
  w,
  h,
  nm,
  ddd,
  assets,
  layers,
  markers
};
export {
  assets,
  ddd,
  quedaAnim as default,
  fr,
  h,
  ip,
  layers,
  markers,
  meta,
  nm,
  op,
  v,
  w
};
//# sourceMappingURL=queda-ox-60.json.js.map
